import { XMarkIcon } from "@heroicons/react/24/outline";
import { MdDone } from "react-icons/md";

const ClosingStatus = ({ closure_status }) => {
  return (
    <>
      {closure_status ? (
        <div className="flex items-center gap-2">
          {/* Green circle with icon inside */}
          <span className="relative flex h-5 w-5 items-center justify-center">
            <span className="absolute inline-flex rounded-full h-full w-full bg-green-500"></span>
            <MdDone className="w-3 h-3 text-white relative z-10" />
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          {/* Red circle with icon inside */}
          <span className="relative flex h-5 w-5 items-center justify-center">
            <span className="absolute inline-flex rounded-full h-full w-full bg-red-600"></span>
            <XMarkIcon className="w-3 h-3 text-white relative z-10" />
          </span>
        </div>
      )}
    </>
  );
};

export default ClosingStatus;
